import { useInfiniteQuery } from 'react-query';
import type { UseInfiniteQueryOptions } from 'react-query';
import {
  getLatestPhotoCards,
  type GetLatestPhotoCardsResponse
} from '../../services/photoCardService';

const DEFAULT_PER_PAGE = 10;

export function useGetLatestPhotoCards(
  perPage = DEFAULT_PER_PAGE,
  options?: UseInfiniteQueryOptions<GetLatestPhotoCardsResponse, Error>
) {
  return useInfiniteQuery<GetLatestPhotoCardsResponse, Error>(
    ['latestPhotoCards', perPage],
    ({ pageParam = 1 }) =>
      getLatestPhotoCards({ query: { page: pageParam, per_page: perPage } }),
    {
      getNextPageParam: (lastPage) => {
        const { currentPage, totalPages } = lastPage.meta.pagination;
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      ...options
    }
  );
}
